const main = {
	state: {
		project: null,
		distribute: {
			distribute: null,
			list: []
		},
		qaedas: {
			lot_system: null,
			video_system: null,
			trace_system: null,
			production_system: null
		},
		user: {
			m_qaedas_id: 1,
			onload: true
		},
		qaedasUlist: {
			list: null,
			page: {
				total: 0
			}
		}
	},
	mutations: {
		project(state,value)
		{
			state.project=value;
		},
		distribute(state,value)
		{
			state.distribute=value;
		},
		qaedas(state,value)
		{
			state.qaedas=value;
		},
		user(state,value)
		{
			state.user=value;
		},
		qaedasUlist(state,value)
		{
			state.qaedasUlist=value;
		},
		setdw(state)
		{
			let width = window.innerWidth - 290;
			let height = width / 2.2;
			for(var i=0;i<state.distribute.list.length;i++)
			{
				state.distribute.list[i]["width"]=width*state.distribute.list[i].axis_x+11;
				state.distribute.list[i]["height"]=height*state.distribute.list[i].axis_y-40;
			}
		}
	},
	actions: {
		
	},
	getters: {
		
	}
};
export default {
	namespaced: true,
	main
};
